import { Navigate, Route, Routes } from 'react-router-dom';

import withPermission from 'hooks/withPermission';

import { PATH } from 'constants/path';

import AnalyticsPage from './page/AnalyticsPage';

const AnalyticsRouters = () => {
  return (
    <Routes>
      <Route index element={<AnalyticsPage />} />

      <Route path="*" element={<Navigate to={PATH.ERROR_404} />} />
    </Routes>
  );
};

export default withPermission(['Analytics'])(AnalyticsRouters);
